import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Card, Col, DatePicker, Form, InputNumber, message, Modal, Row, Select, Upload, UploadFile } from 'antd'
import { Option } from 'antd/es/mentions'
import { deleteRequestForm, getRequestAuth, patchRequestForm, postRequestForm } from '../../../request/request'
import { useTranslation } from 'react-i18next'
import moment, { Moment } from 'moment/moment'
import { ContextType } from '../../../type/type'
import { AppContext } from '../../../App'
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors'
import { config } from '../../../config'
import { statusList } from '../../../lists/statusLists'
import { statusReasonsRejection, statusReasonsRejectionObj } from '../../../lists/statusReasonsRejection'
import { RcFile } from 'antd/es/upload'
import '../style/myTableStyle.scss'
import MyUploadFile from '../../../modules/MyUploadFile/MyUploadFile'

interface Props {
  isModalOpen: boolean
  setIsModalOpen: (e: boolean) => void
  trophyTypeList: any[]
  huntingFarmList: any
  isTrophyTypeList: boolean
  isHuntingFarmLoading: boolean
  clearForm: boolean
  setReload: any
  editData: any
  typeModal?: string | undefined | null
}

const MyTrophiesModal: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  trophyTypeList,
  isTrophyTypeList,
  huntingFarmList,
  isHuntingFarmLoading,
  setReload,
  editData,
  clearForm,
  typeModal,
}) => {
  const { state } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [add] = Form.useForm()
  const [addPhoto] = Form.useForm()
  const [addFile, setAddFile] = useState<any>([])
  const [addFileError, setAddFileError] = useState<boolean>(false)
  const [addFileList, setAddFileList] = useState<any>([])
  const [addFileListError, setAddFileListErr] = useState<boolean>(false)
  const [allowedUser, setAllowedUser] = useState<boolean>(false) // вывод дополнительных блоков для админа
  const [blockUpload, setBlockUpload] = useState<boolean>(false) //блокировка кнопки загрузки фото
  const [loading, setLoading] = useState<boolean>(false)
  const [viewDisabled, setViewDisabled] = useState<boolean>(false) // блокировока инпутов (режим просмотра)
  const [changeStatusDisabled, setChangeStatusDisabled] = useState<boolean>(false)// блокировока смены статуса
  const [isHideApplyButton, setIsHideApplyButton] = useState<boolean>(false)// отображение кнопки применить
  const [validateErrors, setValidateErrors]: any = useState({})
  const [valueStatus, setValueStatus]: any = useState(null)
  const [defaultData, setDefaultData]: any = useState(null)
  const dateFormat = 'DD.MM.YYYY'
  const dateFormatServer = 'YYYY-MM-DDT23:00:00Z'
  const maximumFileSize = '50'
  const formatFile = 'JPG/PNG'
  const minimalAmountPhoto = 1
  const options = useMemo(() => statusList(t).slice(1), [t])
  let timeOut: any
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const labelColDefault = 7

  useEffect(() => {
    add.resetFields()
    addPhoto.resetFields()
    setAddFile([])
    setAddFileList([])
  }, [clearForm])

  useEffect(() => {
    const { role } = state?.me?.user || {}
    if (typeModal === 'view') {
      setBlockUpload(true)
      setViewDisabled(true)
      setIsHideApplyButton(true);
    } else if (typeModal === 'edit' || typeModal === 'add') {
      setBlockUpload(false)
      setViewDisabled(false)
      setIsHideApplyButton(false);
    } else if (typeModal === 'admin') {
      const isAdminOrModerator = role === 'ADMINISTRATOR' || role === 'MODERATOR'
      const isApdOrRjc = editData?.status === 'RJC' || editData?.status === 'APD';
      const isAwt = editData?.status === 'AWT'; //для разрешения редактирования статуса
      const isApdOrRjcOrAwt = isApdOrRjc || isAwt //блокировка заявки согласно статуса

      if (isAdminOrModerator) {
        setBlockUpload(isApdOrRjcOrAwt)
        setAllowedUser(true)
        setViewDisabled(isApdOrRjcOrAwt)
        setIsHideApplyButton(isApdOrRjc)
        setChangeStatusDisabled(isApdOrRjc)
      } else {
        setBlockUpload(false)
        setAllowedUser(true)
        setViewDisabled(false)
        setIsHideApplyButton(false)
        setChangeStatusDisabled(false)
      }
    }

    return () => clearTimeout(timeOut)
  }, [typeModal, state, editData])

  useEffect(() => {
    if (typeModal && (typeModal === 'edit' || typeModal === 'admin' || typeModal === 'view') && editData) {
      const {
        point,
        trophy_type,
        hunting_farm,
        date,
        certificate: url,
        photos,
        status,
        reasons_rejection,
      } = editData || {}
      const newDate: Moment = moment(date)
      setValueStatus(status)

      setAddFile([
        {
          id: '-1',
          name: 'image.png',
          status: 'done',
          url: config.auth + url,
        },
      ])

      const photo = photos?.map(({ id, photo, trophy_book }: { id: number; photo: string; trophy_book: string }) => ({
        id,
        trophy_book,
        url: config.auth + photo,
      }))
      setDefaultData(photo)
      setAddFileList(photo)

      const dataObj = {
        status,
        reasons_rejection,
        date: newDate,
        point: parseFloat(point),
        trophy_type: String(trophy_type.id),
        hunting_farm: typeModal === 'view' ? String(hunting_farm.title) : String(hunting_farm.id),
      }

      add.setFieldsValue(dataObj)
    }
  }, [editData, isModalOpen, typeModal])

  const disabledDate = (current: any) => {
    const minDate = new Date(1900, 0, 1)
    const maxDate = moment()
    return current && (current < minDate || current > maxDate)
  }

  const sendFiles = (files: any, index: number, trophyId: any) => {
    if (files?.length === 0) return

    if (index < files.length) {
      const formDataPhoto = new FormData()
      formDataPhoto.append('trophy_book', trophyId)

      if (files[index] instanceof File) {
        formDataPhoto.append('photo', files[index])
      }

      postRequestForm('/trophy_book/trophy_photo', formDataPhoto)
        .then(() => {
          sendFiles(files, index + 1, trophyId)
        })
        .catch((err) => {
          validatorServerErrors(err.data, setValidateErrors)
        })
    } else {
      setLoading(false)
      setIsModalOpen(false)
      setReload((prev: boolean) => !prev)
      add.resetFields()
      addPhoto.resetFields()
    }
  }

  const requestImg = () => {
    addFileList.length > 0 ? setAddFileListErr(false) : setAddFileListErr(true)
    addFile.length > 0 ? setAddFileError(false) : setAddFileError(true)
  }

  const handleFinish = async (values: any) => {
    delete values.certificate
    requestImg()

    if (typeModal === 'add') {
      const formData = new FormData()
      if (addFileList?.length > 0 && addFile.length > 0) {
        const date = convertDate(values.date)
        let body = { ...values, date }

        if (state?.me?.id) {
          body = { ...body, hunter: state.me.id }
        } else {
          try {
            const res = await getRequestAuth('/profile/about_me/')
            const { id } = res.data

            if (id) {
              body = { ...body, hunter: id }
            } else {
              message.error(t('errors.e1'))
              return
            }
          } catch (err: any) {
            validatorServerErrors(err.data, setValidateErrors)
            return
          }
        }

        Object.keys(body).forEach((key) => {
          formData.append(key, body[key])
        })

        if (addFile?.length > 0) {
          if (Object.prototype.hasOwnProperty.call(addFile[0], 'type')) {
            formData.append('certificate', addFile[0].originFileObj)
          }
        }
        if (addFileList?.length > 0) {
          addFileList.forEach((item: File) => {
            formData.append('photos_upload', item)
          })
        }
        /*  setLoading(true)*/

        postRequestForm('/trophy_book/application', formData)
          .then(() => {
            setLoading(false)
            setIsModalOpen(false)
            setReload((prev: boolean) => !prev)
            add.resetFields()
            addPhoto.resetFields()
            message.success(t('h80'))
          })
          .catch((err) => {
            setLoading(false)
            validatorServerErrors(err.data, setValidateErrors)
          })
      }
    }

    if (typeModal === 'edit') {
      const formData = new FormData()

      if (addFileList?.length > 0 && addFile.length > 0) {
        const date = convertDate(values.date)
        const body = { ...values, date, hunter: editData.hunter }

        Object.keys(body).forEach((key) => {
          formData.append(key, body[key])
        })

        if (addFile?.length > 0 && addFile[0]?.originFileObj) {
          if (Object.prototype.hasOwnProperty.call(addFile[0], 'type')) {
            formData.append('certificate', addFile[0].originFileObj)
          }
        }
        setLoading(true)
        patchRequestForm(`/trophy_book/application/${editData.id}`, formData)
          .then(() => {
            handleCancel()
            setReload((prev: boolean) => !prev)
            message.success(t('h80'))
          })
          .catch((err) => {
            setLoading(false)
            validatorServerErrors(err.data, setValidateErrors)
          })
      }
    }

    if (typeModal === 'admin') {
      const formData = new FormData()

      const date = convertDate(values.date)
      const body = { ...values, date }

      if (body.status !== 'RJC') {
        delete body.reasons_rejection
      }

      Object.keys(body).forEach((key) => {
        formData.append(key, body[key])
      })

      // добавляем управление сертификатами в /trophy_book/admin_trophy_book/ новым полем
       if (addFile?.length > 0 && addFile[0]?.originFileObj) {
          if (Object.prototype.hasOwnProperty.call(addFile[0], 'type')) {
            formData.append('certificate', addFile[0].originFileObj)
          }
        }

      patchRequestForm(`/trophy_book/admin_trophy_book/${editData.id}`, formData)
        .then(() => {
          handleCancel()
          setReload((prev: boolean) => !prev)
          message.success(t('h80'))
        })
        .catch((err) => {
          validatorServerErrors(err.data)
        })
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    timeOut = setTimeout(() => {
      add.resetFields()
      addPhoto.resetFields()
      setAddFile([])
      setDefaultData(null)
      setAddFileListErr(false)
      setAddFileList([])
      setLoading(false)
    }, 200)
  }

  const convertDate = (value: any) => {
    return moment(value).format(dateFormatServer)
  }

  const onRemoveImages = (file: any) => {
    if (!file?.type && typeModal === 'edit' || !file?.type && typeModal === 'admin') {
      deleteRequestForm(`/trophy_book/trophy_photo/${file?.id}`)
        .then(() => {
          const updatedFileList = addFileList.filter(({ id }: { id: number }) => id !== file.id)
          setAddFileList(updatedFileList)
          setReload((prev: boolean) => !prev)
        })
        .catch((err: any) => {
          validatorServerErrors(err.data, setValidateErrors)
        })
    }
  }

  const arr: any[] = []
  const onChangeImages = async (file: any) => {
    setAddFileList(file)

    if (typeModal === 'edit' || typeModal === 'admin') {
      const trophyId = editData?.photos[0]?.trophy_book
      const arrAdd: any[] = file.filter((e: any) => e instanceof File)
      const arrNoteFile: any[] = file.filter((e: any) => !(e instanceof File))
      let successfulUploads = 0

      const uploadQueue = async () => {
        for (const item of arrAdd) {
          const formDataPhoto = new FormData()
          formDataPhoto.append('trophy_book', trophyId)
          formDataPhoto.append('photo', item)

          try {
            const res = await postRequestForm(`/trophy_book/trophy_photo`, formDataPhoto)
            successfulUploads++
            const { id, photo, trophy_book } = res?.data || {}
            arr.push({ id, trophy_book, url: photo })

            if (successfulUploads === arrAdd.length) {
              setReload((prev: boolean) => !prev)
              setDefaultData([...arrNoteFile, ...arr])
            }
          } catch (err) {
            console.log('err', err)
          }
        }
      }

      await uploadQueue()
    }
  }

  const convertImgToForm = async (newFileList: any, index: number) => {
    if (index < newFileList?.length) {
      const file = newFileList[index]

      if (file?.size) {
        const isJpgOrPng = file?.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < Number(maximumFileSize)

        if (!isJpgOrPng) {
          message.error(t('h99') + formatFile)
          return
        }

        if (!isLt2M) {
          message.error(t('h98') + maximumFileSize + 'MB!')
          return
        }

        const formDataPhoto = new FormData()
        const trophyId = editData?.photos[0]?.trophy_book

        formDataPhoto.append('trophy_book', trophyId)
        formDataPhoto.append('photo', file)

        postRequestForm('/trophy_book/trophy_photo', formDataPhoto)
          .then((res) => {
            const { id, photo, trophy_book } = res?.data || {}

            setAddFileList((prev: any) => [...prev, { id, trophy_book, url: photo }])
            setReload((prev: boolean) => !prev)
            convertImgToForm(newFileList, index + 1)
          })
          .catch((err: any) => {
            validatorServerErrors(err.data, setValidateErrors)
          })
      }
    }
  }

  const exportMessage = (text: string) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
        <div id="add_point_help" className="ant-form-item-explain ant-form-item-explain-connected" role="alert">
          <div className="ant-form-item-explain-error">{text}</div>
        </div>
        <div style={{ width: 0, height: 24 }}></div>
      </div>
    )
  }

  const removeFileById = (fileId: any) => {
    if (typeModal === 'add') return

    if (addFileList?.length > minimalAmountPhoto) {
      deleteRequestForm(`/trophy_book/trophy_photo/${fileId.id}`)
        .then(() => {
          const updatedFileList = addFileList.filter(({ id }: { id: number }) => id !== fileId.id)
          setAddFileList(updatedFileList)
          setReload((prev: boolean) => !prev)
        })
        .catch((err: any) => {
          validatorServerErrors(err.data, setValidateErrors)
        })
    } else {
      message.error(`${t('h100')} ${minimalAmountPhoto} ${t('h101').toLowerCase()}`)
    }
  }

  const onChangeCertificate = ({ file, fileList: newFileList }: any) => {
    if (file.status !== 'removed') {
      setAddFile(newFileList)
    }
  }

  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = (error) => reject(error)
    })

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile)
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1))
  }

  const handleCancelPreview = () => setPreviewOpen(false)

  const [inputError, setInputError] = useState(false)

  const modalTitle = () => {
    switch (typeModal) {
      case 'add':
        return t('profile.p3')
      case 'edit':
        return `${t('h102')}: ${editData?.trophy_type?.name || '-'}`
      case 'view':
        return `${t('h133')}: ${editData?.trophy_type?.name || '-'}`
      default:
        return `${t('h102')}: ${editData?.trophy_type?.name || '-'}`
    }
  }

  const onChangeFirstSelect = (newValue: string) => {
    setValueStatus(newValue)

    if (newValue !== 'RJC') {
      add.setFieldsValue({ reasons_rejection: undefined }) // Сброс значения второго селекта
    }
  }

  return (
    <Modal title={modalTitle()} width={500} open={isModalOpen} onCancel={handleCancel} className="ptb-0" footer={false}>
      {allowedUser && (
        <>
          {
            editData?.creatorData && (
              <div>
                <h3>{t('h197')}</h3>
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                  <li>
                    {t('h61')}: {editData?.creatorData?.last_name}
                  </li>
                  <li>
                    {t('h62')}: {editData?.creatorData?.first_name}
                  </li>
                  <li>
                    {t('h63')}: {editData?.creatorData?.middle_name}
                  </li>
                  <li>
                    {t('h64')}: {editData?.creatorData?.user?.phone}
                  </li>
                  <li>{t('h49')}: {editData?.creatorData?.user?.email}</li>
                </ul>
                <hr />
              </div>
            )
          }
          <h3>{t('h145')}</h3>
          <ul style={{ listStyle: 'none', paddingLeft: 0, marginBottom: 0 }}>
            <li>
              {t('h61')}: {editData?.hunter?.last_name}
            </li>
            <li>
              {t('h62')}: {editData?.hunter?.first_name}
            </li>
            <li>
              {t('h63')}: {editData?.hunter?.middle_name}
            </li>
            <li>
              {t('h64')}: {editData?.hunter?.phone}
            </li>
            <li>Email: {editData?.hunter?.email}</li>
          </ul>
        </>
      )}

      {/*<Row gutter={64}>*/}
      {/*  <Col*/}
      {/*    xs={{ span: 24 }}*/}
      {/*    sm={{ span: 24 }}*/}
      {/*    lg={{ span: 15 }}*/}
      {/*    style={{ borderRight: '1px solid #E7EDE3', paddingTop: 24, paddingBottom: 24 }}*/}
      {/*  >*/}
      <br />
      <Form
        name="add"
        layout="vertical"
        form={add}
        initialValues={{ reasons_rejection: '' }}
        autoComplete="off"
        onFinish={handleFinish}
      >
        <Form.Item
          name="trophy_type"
          label={t('h116')}
          rules={[{ required: true, message: t('h104') }]}
          validateStatus={validateErrors?.trophy_type ? 'error' : ''}
          help={validateErrors?.trophy_type}
        >
          <Select placeholder={t('h104')} allowClear loading={isTrophyTypeList} disabled={viewDisabled}>
            {trophyTypeList?.map(
              ({ id, name }: { id: number; name: string }, index) =>
                index !== 0 && (
                  <React.Fragment key={id}>
                    <Option value={String(id)}>{name}</Option>
                  </React.Fragment>
                ),
            )}
          </Select>
        </Form.Item>
        <Form.Item
          name="hunting_farm"
          label={t('h117')}
          rules={[{ required: true, message: t('h105') }]}
          validateStatus={validateErrors?.hunting_farm ? 'error' : ''}
          help={validateErrors?.hunting_farm}
        >
          <Select
            showSearch
            placeholder={t('h105')}
            allowClear
            loading={isHuntingFarmLoading}
            disabled={viewDisabled}
            filterOption={(input, option: any) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
          >
            {huntingFarmList?.map(({ id, title }: { id: number; title: string }) => (
              <React.Fragment key={id}>
                <Option value={String(id)}>{title}</Option>
              </React.Fragment>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={t('h158')}
          name="date"
          rules={[{ required: true, message: t('h159') }]}
          validateStatus={validateErrors?.date ? 'error' : ''}
          help={validateErrors?.date}
        >
          <DatePicker
            showToday={false}
            placeholder={t('h159')}
            format={dateFormat}
            style={{ width: '100%' }}
            disabledDate={disabledDate}
            disabled={viewDisabled}
          />
        </Form.Item>
        <Form.Item
          name="point"
          label={t('h118')}
          validateStatus={validateErrors?.point || inputError ? 'error' : ''}
          help={validateErrors?.point}
          rules={[
            { required: true, message: t('h108') },
            {
              pattern: /^\d+(\.\d{0,2})?$/,
              message: t('h126'),
            },
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            onKeyDown={(e: any) => {
              if ((e.key === '.' && e.target.value.includes('.')) || (e.key === ',' && e.target.value.includes(','))) {
                e.preventDefault()
              }
            }}
            onKeyUp={(e: any) => (e.target.value = e.target.value.replace(/[^0-9.]/g, ''))}
            disabled={viewDisabled}
          />
        </Form.Item>
        <Form.Item
          name="certificate"
          label={t('h119')}
          valuePropName="fileList"
          validateStatus={validateErrors?.certificate ? 'error' : ''}
          help={validateErrors?.certificate}
          rules={[
            {
              required: true,
              validator: (rule, value) => {
                if (!value && addFile.length === 0) {
                  return Promise.reject(t('h108'))
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <Upload
            id="certificate"
            disabled={blockUpload}
            fileList={addFile}
            listType="picture-card"
            accept="image/png, image/jpeg, image/jpg"
            onChange={onChangeCertificate}
            onPreview={handlePreview}
            onRemove={() => setAddFile([])}
            beforeUpload={(file) => {
              // сохраняем файл в локальный state, но отменяем auto-upload
              setAddFile([file]);
              return false; // ← отменяем запрос к серверу
            }}
          >
            {addFile.length < 1 && `+ ${t('h115')}`}
          </Upload>

          <Modal
            open={previewOpen}
            title={previewTitle}
            className="fz-12-title"
            footer={null}
            onCancel={handleCancelPreview}
          >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
          </Modal>
          {addFileError && exportMessage(t('h108'))}
        </Form.Item>
        {allowedUser && (
          <>
            <Form.Item name="status" label={t('h109')} rules={[{ required: true, message: `${t('h110')!}` }]}>
              <Select
                style={{ width: '100%' }}
                options={options}
                onChange={onChangeFirstSelect}
                disabled={changeStatusDisabled}
              />
            </Form.Item>
            <Form.Item
              name="reasons_rejection"
              label={t('h111')}
              rules={[{ required: valueStatus === 'RJC', message: `${t('h112')}!` }]}
            >
              <Select
                placeholder={t('h112')}
                style={{ width: '100%' }}
                disabled={changeStatusDisabled || valueStatus !== 'RJC'}
                allowClear
                options={statusReasonsRejection(t)}
              />
            </Form.Item>
          </>
        )}
        {viewDisabled && editData?.reasons_rejection && (
          <Form.Item name="reasons_rejection" label={t('h111')}>
            <div style={{ color: '#f00', marginTop: 4 }}>
              {statusReasonsRejectionObj(t, editData?.reasons_rejection)}
            </div>
          </Form.Item>
        )}
        <Form name="addPhoto" layout="vertical" form={addPhoto} initialValues={{ remember: true }} autoComplete="off">
          <Form.Item
            label={
              <>
                <span className="required">{t('h114')}</span>
              </>
            }
            valuePropName="fileList"
            name="photo"
            rules={[
              {
                validator: (rule, value) => {
                  if (!value && addFileList.length === 0) {
                    return Promise.reject(t('rules.r5'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <>
              <MyUploadFile
                multiple
                preview
                onChange={onChangeImages}
                onRemove={onRemoveImages}
                maxFiles={3}
                minFiles={1}
                dontFixLimitDelete={typeModal !== 'add'}
                disabled={blockUpload}
                defaultData={defaultData}
              />

              {addFileListError && exportMessage(t('h108'))}
            </>
          </Form.Item>
        </Form>

        {!isHideApplyButton && (
          <div className="text-center">
            <Button key="submit" htmlType="submit" type="primary" loading={loading} className="modalBtn">
              {typeModal === 'add' ? t('h113') : t('h60')}
            </Button>
          </div>
        )}
      </Form>

      {/*</Col>*/}
      {/*<Col span={9} style={{ paddingTop: 24, paddingBottom: 24 }}></Col>*/}
      {/*</Row>*/}
    </Modal>
  )
}

export default MyTrophiesModal
